const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls } = wp.blockEditor;
const { Button, PanelBody, Icon } = wp.components;
const { Fragment, useState } = wp.element;
const { __ } = wp.i18n;

registerBlockType('pg/checklist', {
  title: 'PG Checklist',
  icon: 'editor-ul',
  category: 'layout',
  attributes: {
    title: {
      type: 'string',
      default: '',
    },
    items: {
      type: 'array',
      default: [],
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { title, items } = attributes;

    const addItem = () => {
      setAttributes({ items: [...items, ''] });
    };

    const updateItem = (index, value) => {
      const newItems = [...items];
      newItems[index] = value;
      setAttributes({ items: newItems });
    };

    const removeItem = (index) => {
      const newItems = items.filter((_, i) => i !== index);
      setAttributes({ items: newItems });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Checklist Settings')}>
            <Button isPrimary onClick={addItem}>
              <Icon icon="insert" /> {__('Add Item')}
            </Button>
          </PanelBody>
        </InspectorControls>
        <div className="check-list">
          <RichText
            tagName="h3"
            value={title}
            onChange={(value) => setAttributes({ title: value })}
            placeholder={__('Enter title...')}
          />
          {items.map((item, index) => (
            <div key={index} className="check-item">
              <RichText
                tagName="div"
                value={item}
                onChange={(value) => updateItem(index, value)}
                placeholder={__('Enter checklist item...')}
              />
              <Button isDestructive onClick={() => removeItem(index)}>
                <Icon icon="trash" /> {__('Remove Item')}
              </Button>
            </div>
          ))}
          <Button isPrimary onClick={addItem}>
            {__('Add Item')}
          </Button>
        </div>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const { title, items } = attributes;

    return (
      <div className="check-list">
        {title && <RichText.Content tagName="h3" value={title} />}
        {items.map((item, index) => (
          <RichText.Content
            key={index}
            tagName="div"
            className="check-item"
            value={item}
          />
        ))}
      </div>
    );
  },
});
